import * as React from 'react';
import styled from 'styled-components';
import { Carousel, CarouselItem, CarouselIndicators, CarouselControl } from 'reactstrap';

const defaultItems = [
  {
    src: 'https://i.imgur.com/ulkFVNg.png',
    altText: 'Slide 1',
  },
  {
    src: 'https://i.imgur.com/9UjUBT4.jpg',
    altText: 'Slide 2',
  },
  {
    src: 'https://i.imgur.com/dDaQB8n.jpg',
    altText: 'Slide 3',
  },
];

const CarouselImage = styled<{ imgSource: string }, 'div'>('div')`
  display: block;
  height: 440px;
  width: 100%;
  background: url(${props => props.imgSource}) no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
`;

interface state {
  activeIndex: number;
  animating: boolean;
}

interface item {
  src: string;
  altText: string;
}

interface props {
  items?: item[];
}

class ImageCarousel extends React.Component<props, state> {
  state = {
    activeIndex: 0,
    animating: false,
  };

  constructor(props: any) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goToIndex = this.goToIndex.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  onExiting() {
    this.setState({ animating: true });
  }

  onExited() {
    this.setState({ animating: false });
  }

  get items() {
    return this.props.items && this.props.items.length !== 0 ? this.props.items : defaultItems;
  }

  next = () => {
    if (this.state.animating) return;
    const nextIndex =
      this.state.activeIndex === this.items.length - 1 ? 0 : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  };

  previous = () => {
    if (this.state.animating) return;
    const nextIndex =
      this.state.activeIndex === 0 ? this.items.length - 1 : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  };

  goToIndex(newIndex: number) {
    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

    const slides = this.items.map(item => {
      return (
        <CarouselItem onExiting={this.onExiting} onExited={this.onExited} key={item.src}>
          <CarouselImage imgSource={item.src} />
        </CarouselItem>
      );
    });

    return (
      <>
        <Carousel activeIndex={activeIndex} next={this.next} previous={this.previous}>
          <CarouselIndicators
            items={this.items}
            activeIndex={activeIndex}
            onClickHandler={this.goToIndex}
          />
          {slides}
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={this.previous}
          />
          <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
        </Carousel>
      </>
    );
  }
}

export default ImageCarousel;



// WEBPACK FOOTER //
// ./src/components/ImageCarousel.tsx